export const ProjectActionTypes = {
    LOGOUT: 'LOGOUT',

    ADD_PROJECT_REQUEST: 'ADD_PROJECT_REQUEST',
    ADD_PROJECT_REQUEST_SUCCESS: 'ADD_PROJECT_REQUEST_SUCCESS',
    ADD_PROJECT_REQUEST_ERROR: 'ADD_PROJECT_REQUEST_ERROR',
    ADD_PROJECT_REQUEST_STATUS: 'ADD_PROJECT_REQUEST_STATUS',

    PROJECT_LIST_REQUEST: 'PROJECT_LIST_REQUEST',
    PROJECT_LIST_REQUEST_SUCCESS: 'PROJECT_LIST_REQUEST_SUCCESS',
    PROJECT_LIST_REQUEST_ERROR: 'PROJECT_LIST_REQUEST_ERROR',

    PROJECT_DETAIL_REQUEST: 'PROJECT_DETAIL_REQUEST',
    PROJECT_DETAIL_REQUEST_SUCCESS: 'PROJECT_DETAIL_REQUEST_SUCCESS',
    PROJECT_DETAIL_REQUEST_ERROR: 'PROJECT_DETAIL_REQUEST_ERROR',

    PROJECT_UPATE_DETAIL_REQUEST: 'PROJECT_UPATE_DETAIL_REQUEST',
    PROJECT_UPATE_DETAIL_REQUEST_SUCCESS: 'PROJECT_UPATE_DETAIL_REQUEST_SUCCESS',
    PROJECT_UPATE_DETAIL_REQUEST_ERROR: 'PROJECT_UPATE_DETAIL_REQUEST_ERROR',
    PROJECT_UPATE_DETAIL_REQUEST_STATUS: 'PROJECT_UPATE_DETAIL_REQUEST_STATUS',

    PROJECT_ASSIGN_EMPLOYEE_REQUEST: 'PROJECT_ASSIGN_EMPLOYEE_REQUEST',
    PROJECT_ASSIGN_EMPLOYEE_REQUEST_SUCCESS: 'PROJECT_ASSIGN_EMPLOYEE_REQUEST_SUCCESS',
    PROJECT_ASSIGN_EMPLOYEE_REQUEST_ERROR: 'PROJECT_ASSIGN_EMPLOYEE_REQUEST_ERROR',
    PROJECT_ASSIGN_EMPLOYEE_REQUEST_STATUS: 'PROJECT_ASSIGN_EMPLOYEE_REQUEST_STATUS',

    PROJECT_REMOVE_EMPLOYEE_REQUEST: 'PROJECT_REMOVE_EMPLOYEE_REQUEST',
    PROJECT_REMOVE_EMPLOYEE_REQUEST_SUCCESS: 'PROJECT_REMOVE_EMPLOYEE_REQUEST_SUCCESS',
    PROJECT_REMOVE_EMPLOYEE_REQUEST_ERROR: 'PROJECT_REMOVE_EMPLOYEE_REQUEST_ERROR',
    PROJECT_REMOVE_EMPLOYEE_REQUEST_STATUS: 'PROJECT_REMOVE_EMPLOYEE_REQUEST_STATUS',

    REQUEST_PROJECT_REQUEST: 'REQUEST_PROJECT_REQUEST',
    REQUEST_PROJECT_REQUEST_SUCCESS: 'REQUEST_PROJECT_REQUEST_SUCCESS',
    REQUEST_PROJECT_REQUEST_ERROR: 'REQUEST_PROJECT_REQUEST_ERROR',
    REQUEST_PROJECT_REQUEST_STATUS: 'REQUEST_PROJECT_REQUEST_STATUS',

    REJECT_EMPLOYEE_PROJECT_REQUEST: 'REJECT_EMPLOYEE_PROJECT_REQUEST',
    REJECT_EMPLOYEE_PROJECT_REQUEST_SUCCESS: 'REJECT_EMPLOYEE_PROJECT_REQUEST_SUCCESS',
    REJECT_EMPLOYEE_PROJECT_REQUEST_ERROR: 'REJECT_EMPLOYEE_PROJECT_REQUEST_ERROR',
    REJECT_EMPLOYEE_PROJECT_REQUEST_STATUS: 'REJECT_EMPLOYEE_PROJECT_REQUEST_STATUS'
}